import { LandingPageConfig } from 'rangeConfig/@types';
import ladmakareGalleryConfig from './ladmakareGalleryConfig';
import ladmakareInspirationImg from '../../views/LandingPage/images/ladmakare_inspiration.png';
import landingPageImg from '../../views/LandingPage/images/ladmakare_landing_page.jpg';
import designFromScratch from '../../views/LandingPage/images/designFromScratch.jpg';

const ladmakareLandingPageConfig: LandingPageConfig = {
  rangeDesign: {
    backgroundImgUrl: landingPageImg,
    titleTextColor: '#FFFFFF'
  },
  designFromScratch: {
    backgroundColor: '#C1B69B',
    backgroundImgUrl: designFromScratch
  },
  openDesign: {
    backgroundColor: '#F5F5F5',
    backgroundImgUrl: ladmakareInspirationImg
  },
  browseInspiration: {
    backgroundColor: '#E6C6AF',
    backgroundImgUrl: '',
    galleryConfig: ladmakareGalleryConfig
  }
};

export default ladmakareLandingPageConfig;
